import { Category } from '@/types/shared/category'

export const allergen1: Category = {
    id: 1,
    name: 'Gluten',
    priority: 1,
}

export const allergen2: Category = {
    id: 2,
    name: 'Crustacés',
    priority: 1,
}

export const allergen3: Category = {
    id: 3,
    name: 'Œufs',
    priority: 1,
}

export const allergen4: Category = {
    id: 4,
    name: 'Poissons',
    priority: 1,
}

export const allergen5: Category = {
    id: 5,
    name: 'Arachides',
    priority: 1,
}

export const allergen6: Category = {
    id: 6,
    name: 'Soja',
    priority: 1,
}

export const allergen7: Category = {
    id: 7,
    name: 'Lait',
    priority: 1,
}

export const allergen8: Category = {
    id: 8,
    name: 'Fruits à coque',
    priority: 1,
}

export const allergen9: Category = {
    id: 9,
    name: 'Céleri',
    priority: 2,
}

export const allergen10: Category = {
    id: 10,
    name: 'Moutarde',
    priority: 2,
}

export const allergen11: Category = {
    id: 11,
    name: 'Graines de sésame',
    priority: 2,
}

export const allergen12: Category = {
    id: 12,
    name: 'Anhydride sulfureux et sulfites',
    priority: 2,
}

export const allergen13: Category = {
    id: 13,
    name: 'Lupin',
    priority: 2,
}

export const allergen14: Category = {
    id: 14,
    name: 'Mollusques',
    priority: 2,
}

export const allergen15: Category = {
    id: 15,
    name: 'Lactose',
    priority: 3,
}

export const allergen16: Category = {
    id: 16,
    name: 'Noix',
    priority: 3,
}

export const allergen17: Category = {
    id: 17,
    name: 'Amandes',
    priority: 3,
}

export const allergen18: Category = {
    id: 18,
    name: 'Noisettes',
    priority: 3,
}

export const allergen19: Category = {
    id: 19,
    name: 'Pistaches',
    priority: 3,
}

export const allergen20: Category = {
    id: 20,
    name: 'Noix de cajou',
    priority: 3,
}
